import { defineStore } from 'pinia'
import $api from '@/plugins/axios';

export const useAuthStore = defineStore('AuthStore', {
  state: () => {
    return {
    }
  },
  actions: {
    /** digested code 유효성 확인(이메일 유효시간 체크용) */
    async getValid(params) {
      return await $api.post(`/auth/valid`, {code : params.code});
    },
    /** 원장 가입용 이메일 전송 */
    async postEmail(params) {
      return await $api.post('/auth/email', { email: params.email });
    },
    /** 원장 가입 코드 검증 */
    async putEmail(params) {
      return await $api.put('/auth/email', { code: params.code });
    },
    /** 원장 가입 */
    async postOwners(params) {
      return await $api.post('/customers/owners', params);
    },
    /** 원장 가입 최종 완료 (구독서비스 동의추가) */
    async postAcceptSubscription() {
      return await $api.post('/customers/owners/accept-subscriptions');
    },
    /** 이메일 중복 체크 */
    async getGroupdIdExist(params) {
      return await $api.get(`/auth/group-id/exists?groupId=${params.groupId}`);
    },
    /** 로그인 */
    async postLogin(params) {
      return await $api.post('/auth/login', {
        userId: params.userId,
        passwd: params.passwd,
      });
    },
    /** 비밀번호 초기화용 이메일 전송 */
    async postResetRequestPw(params) {
      return await $api.post('/auth/email/request-reset-password', { email: params.email });
    },
    /** 비밀번호 초기화 */
    async putResetRequestPw(params) {
      return await $api.put('/auth/email/reset-password', {
        password: params.password,
        code: params.code,
      });
    },
    /** 운영관리자 가입용 Api */
    async putManagerAuth(params) {
      return await $api.put('/auth/email/managers', {
        code: params.code,
        name: params.name,
        phone: params.phone,
        password: params.password,
      });
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    },
    /** 전화번호 인증 요청 */
    async postCertifyPhone(params) {
      return await $api.post(`/auth/phone`, params)
    },
    async putCertifyPhone(params) {
      return await $api.put(`/auth/phone`, params)
    }
  },
  getters: {

  }
})
